import Parser from 'html-react-parser';
import { AiFillStar } from "react-icons/ai"

const ReviewInfo = ({ review }) => {
  var fullname = review.name;
  var imgReferal =  `images/${review.referal}.png` ;

    if (fullname)  {
    var lenfirstspace = fullname.indexOf(" ") ;
    var abrevName = fullname.substring(0, lenfirstspace + 2);
    abrevName = abrevName + ".";
    } else {
    abrevName = "Anonymous";
    }

    var DateDiff = function (type, start, end) {

      let // or var
          years = end.getFullYear() - start.getFullYear(),
          monthsStart = start.getMonth(),
          monthsEnd = end.getMonth()
      ;
  
      if(['m', 'mm', 'month', 'months'].includes(type) )
          return ( ( ( years * 12 ) - ( 12 - monthsEnd ) ) + ( 12 - monthsStart ) );
      else if(['y', 'yy', 'year', 'years'].includes(type))
          return years;
      else if (['d', 'dd', 'day', 'days'].indexOf(type) !== -1 )
          return ( ( end - start ) / ( 1000 * 60 * 60 * 24 ) );
      else
          return -1;
  
  }
  var amtdays = DateDiff('d', new Date(review.date), new Date());
  var howlongago = '';

    
    if (  amtdays > 1 )     {
      amtdays = Math.round(amtdays);
      howlongago = `${amtdays} days ago`;
    }
    if ( amtdays > 30 ) {
    var months = Math.round(amtdays/30);
    howlongago = `${months} months ago`;
    
    }
   if ( amtdays> 365 )     {
      howlongago = ` 1 year ago`;
    }
   if ( amtdays> 730)     {
      howlongago = ` 2 years ago`;
    }if ( amtdays> 1095)     {
      howlongago = ` over 2 years ago`;
    }

   const backgroundColors = ['c9bd3b', '2caed6',   'ee006e', '9d4fa9','44ba59', '736d21', '18627a', '88033e', '5a2d60','266a32  ']

  return (


      <div className="card" itemProp="review" itemScope itemType="http://schema.org/Review">
          <div className="card-body">


                  {review && review.images && review.images.startsWith('https') ? (
                          <div className="card-pic"> <img src={review.images} alt="Donor Photo" width="120" height="120" className="img-responsive" />     </div>
                  ) : (
                      <div className="card-initial"
                           style={{backgroundColor: `#${backgroundColors[Math.floor(Math.random() * backgroundColors.length)]}`}}>
                          {abrevName ? abrevName.charAt(0) : ''}
                      </div>

                  )}


              <p className="card-title" itemProp="author">{abrevName}</p>
              <p className="card-rating" data-rating={`star${review.rating}`}>

                  <span className={'rating ratings' + review.rating} itemProp="reviewRating" itemScope
                       itemType="http://schema.org/Rating">
                      <meta itemProp="ratingValue" content={review.rating}/>
                      <meta itemProp="bestRating" content="5"/>
                      <AiFillStar color="#fabb27"/>
                      {review.rating >= 2 && (
                          <AiFillStar color="#fabb27"/>)}
                      {review.rating >= 3 && (
                          <AiFillStar color="#fabb27"/>)}
                      {review.rating >= 4 && (
                          <AiFillStar color="#fabb27"/>)}
                      {review.rating >= 5 && (
                          <AiFillStar color="#fabb27"/>
                      )}

                  </span>

                  <span>{howlongago}</span>
              </p>

              <meta itemProp="itemReviewed" content="Kars4kids"/>
              <p className="card-text" itemProp="reviewBody"> {review.review && (
                  Parser(review.review)
                  )}</p>
              {review.referal && (
              <p className="card-logo"><img src={imgReferal} width="60" height="14" alt={`As seen on ${review.referal}`} /></p>
                  )}
          </div>
      </div>



    
      )
}

      export default ReviewInfo